<template>
  <container>
    <mu-content-block style="padding:0;">
      <div class="list-header">
        <span class="require-item">* </span>{{title}}
      </div>
      <!--问题原因-->
      <mu-cell v-for="(data,index) in problem" :key="index" class="help-cell" @click.native="select(index)">
        <div slot="left">
          {{data.content}}
        </div>
        <div slot="right">
          <icon value="selected" color="#488bf4" :size="16" v-show="index === problemItem.choose"></icon>
        </div>
      </mu-cell>
      <!--其他原因输入框-->
      <mu-cell :height="10" >
        <div slot="center">
          <textarea class="input" placeholder="其他（不超过100字）" @click="inputReport" v-model="postData.content"></textarea>
        </div>
      </mu-cell>
    </mu-content-block>

    <!--上传图片部分-->
    <mu-content-block style="padding: 0;">
      <div class="list-header">
        上传凭证（最多上传3张图片）
      </div>
      <mu-flexbox class="img-flex-box" justify="flex-start">
        <!-- &lt;!&ndash;已上传图片展示&ndash;&gt; -->
        <mu-flexbox-item v-for="(item,index) in imgArr" class="img-flex-item" grow="0">
          <img :src="item" alt="" class="upload-img" ref="imageArr">
          <icon value="delete" :size="30" class="img-delect" @click.native="deleteImg(index)" color="#488bf4"></icon>
        </mu-flexbox-item>
        <!-- &lt;!&ndash;上传图片按钮&ndash;&gt; -->
        <mu-flexbox-item class="img-flex-item-add" grow="0" v-show="imgArr.length < 3">
          <input type="file" style="display: none" id="upImg" @change="handleFileChange" ref="imgInput">
          <label for="upImg">
            <icon value="add" color="#488bf4" :size="35" click="upImg.click()"></icon>
          </label>
        </mu-flexbox-item>
      </mu-flexbox>
    </mu-content-block> 
    <mu-content-block class="phone-num">
      <mu-input label="手机号码" :hairline="false" v-model="postData.mobile" @click.native="mobileReport"></mu-input>
    </mu-content-block>

    <mu-button text="提交" color="primary" class="submit-btn" @click.native="submit"></mu-button>
    <canvas style="display: none" ref="canvas"></canvas>
    <canvas style="display: none" ref="tCanvas"></canvas>
  </container>
</template>
<style lang="less" rel="stylesheet/less" scoped="">
  @import "../../utils/_vars.less";
  @import "../../utils/_mixins.less";

  .container {
    padding-top: 1rem;

    .input {
      height: 8rem;
      width: 100%;
      border: none;
      padding: 0 1rem;
    }

    .upload-img {
      height: 8rem;
      width: 8rem;
    }

    .img-delect {
      position: absolute;
      top: 0;
      right: 0;
    }

    .img-flex-item {
      padding: 2rem 0.5rem;
      position: relative;
      width: 10rem;
    }

    .img-flex-item-add {
      padding: 2.2rem 0.5rem;
      width: 10rem;

      label {
        height: 8rem;
        width: 8rem;
        display: block;
        background: #f3f3f3;
        line-height: 8rem;
      }
    }

    .phone-num {
      /*height: 5rem;*/
      /*line-height: 5rem;*/
    }

    .submit-btn {
      width: 80%;
      margin: 2rem auto 3rem auto;
    }

    .cell.line:after {
      height: 2px;
    }

  }

  .list-header {
    position: relative;
    height: 3.2rem;
    line-height: 3.2rem;
    font-size: 1.5rem;
    padding-left: 2rem;
    background: #fff;
    color: @textDefault;

    .require-item {
      margin-left: -1rem;
      color: red;
    }

    .hairline(bottom, #e4e4e4);

    &:after {
      height: 2px;
    }

    &:before {
      content: '';
      position: absolute;
      right: 0;
      top: 0;
      left: 0;
      bottom: auto;
      width: @blueLineSpace;
      height: 100%;
      background-color: @primary;
      display: block;
      z-index: 15;
    }
  }

  .help-cell {
    margin-left: 2rem;
    font-size: 1.5rem;
    color: @textDefault;
    min-height: 5rem !important;
    padding: 1.5rem 2rem 1.5rem 0 !important;
    height: auto !important;
  }

</style>
<script  >
  import { mapState, mapGetters } from 'vuex';
  import * as qiniu from 'qiniu-js';
  import webapi from '../../request/webapi.js';
  import { RndNum } from '../../utils';
  import md5 from 'md5';

  let mock = {
    title: '描述绑卡失败的原因',
    problemItems: [{
      text: '没有找到对应银行'
    }, {
      text: '绑定不成功'
    }, {
      text: '已经绑定了银行卡但是没有看到'
    }, {
      text: '提示银行卡信息已存在'
    }]
  };
  export default {
    data() {
      return {
        title: '',
        problem: mock,
        problemItem: {},
        imgArr: [],
        // 文件上传数组
        fileArr: [],
        token: '',
          postData_content: '',
        postData: {
          imageList: [],
          content: '',
          problemId: 0,
          mobile: ''
        }
      };
    },
    mounted() {
      // console.log(qiniu.getUploadUrl())
      // 根据参数请求接口
      this.getProblemItems(this.$route.name);
      this.postData.mobile = this.user.mobile;
    },
    methods: {
      async getProblemItems(name) {
        let param;
        switch (name) {
          case 'addBanckCardProb':
            param = 'bind_bank_card';
            this.title = '描述绑卡失败的原因';
            break;
        }
        console.log(param);
        this.$showLoader();
        try {
          let res = await webapi.problem.getProblemList({ questionType: param });
          if (res.statusCode === 200) {
            this.problem = res.result;
            this.$hideLoader();
          }
          else {
            this.$hideLoader();
            this.$showToast(res.message);
          }
        }
        catch (e) {
          console.log(e);
          this.$hideLoader();
          this.$showToast('参数错误')
        }
      },
      select(index) {
        this.$reportLog(`card_problem_item_${this.problem[index].id}`, 'btn', this.problem[index].content);
        this.problemItem = {};
        this.problemItem.choose = index;
      },
      deleteImg(index) {
        this.imgArr.splice(index, 1);
        this.fileArr.splice(index, 1);
      },
      // 选取图片
      async handleFileChange(e) {
        this.$reportLog('card_problem_add_image', 'btn', '添加图片');
        // let $this = this;
        let inputDOM = e.target;
        let file = inputDOM.files[0];
        // console.log(inputDOM.files[0]);
        // if (\^image\.test(file.type))
        // console.log(e);
        // console.log(inputDOM.files);
        // this.fileArr.push(inputDOM.files[0]);
        this.showImg(inputDOM.files[0]);
        // this.upLoadImg();
      },
      // 展示图片
      async showImg(file) {
        let $this = this;
        let reader = new window.FileReader();
        await reader.readAsDataURL(file);
        reader.onloadend = async (e) => {
          $this.imgArr.push(e.target.result);
          // 判断图片尺寸，小于500k压缩80%，大于500k压缩50%
          if (file.size < 500 * 1024 * 1000) {
            try {
              await $this.compress(e.target.result, 0.8);
            }
            catch (e) {
              console.log(e);
              this.img = e.target.result;
            }
          }
          else {
            try {
              await $this.compress(e.target.result, 0.5);
            }
            catch (e) {
              console.log(e);
              $this.fileArr.push(e.target.result);
            }
          }
        };
      },
      // 压缩图片
      compress(base, ratio) {
        let img = new Image();
        let $this = this;
        let oRatio = ratio;
        img.src = base;
        img.onload = function () {
          let initSize = img.src.length;
          let width = img.width;
          let height = img.height;
          let canvas = $this.$refs.canvas;
          let ctx = canvas.getContext('2d');
          let tCanvas = $this.$refs.tCanvas;
          let tctx = tCanvas.getContext('2d');
          // 如果图片大于四百万像素，计算压缩比并将大小压至400万以下
          let ratio;
          if ((ratio = width * height / 4000000) > 1) {
            ratio = Math.sqrt(ratio);
            width /= ratio;
            height /= ratio;
          }
          else {
            ratio = 1;
          }
          canvas.width = width;
          canvas.height = height;
          // 铺底色
          ctx.fillStyle = '#fff';
          ctx.fillRect(0, 0, canvas.width, canvas.height);
          // 如果图片像素大于100万则使用瓦片绘制
          let count;
          if ((count = width * height / 1000000) > 1) {
            count = ~~(Math.sqrt(count) + 1); // 计算要分成多少块瓦片
            // 计算每块瓦片的宽和高
            let nw = ~~(width / count);
            let nh = ~~(height / count);
            tCanvas.width = nw;
            tCanvas.height = nh;
            for (let i = 0; i < count; i++) {
              for (let j = 0; j < count; j++) {
                tctx.drawImage(img, i * nw * ratio, j * nh * ratio, nw * ratio, nh * ratio, 0, 0, nw, nh);
                ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh);
              }
            }
          }
          else {
            console.log('img', width, height)
            ctx.drawImage(img, 0, 0, width, height);
          }
          // 进行最小压缩
          canvas.toBlob((ndata) => {
            console.log('压缩前：' + initSize);
            console.log('压缩后：' + ndata.size);
            console.log('压缩率：' + ~~(100 * (initSize - ndata.size) / initSize) + '%');
            $this.fileArr.push(ndata);
            tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0;
            if (ndata) {
              console.log('base64压缩成功');
            }
          }, 'image/jpeg', oRatio);
        };
      },
      // 上传图片
      async upLoadImg() {
        let $this = this;
        await Promise.all(this.upLoadStart()).then((res) => {
          this.postData.imageList = res;
        }).catch(() => {
          throw new Error('上传失败');
        });
      },
      upLoadStart() {
        let arr = [];
        for (let i = 0; i < this.fileArr.length; i++) {
          let promise = new Promise(async (resolve, reject) => {
            let token;
            let rndNum = RndNum(5);
            let key = `${this.user.userToken}_${this['common/common'].appJson.comm.pid}_${rndNum}`;
            key = md5(key);
            // 获取token
            try {
              const res = await webapi.upload.getUploadToken({ dictionary: 'problem', fileName: key });
              console.log(res);
              if (res.status === 200) {
                token = res.text;
              }
              else {
                this.$showToast('上传失败')
              }
            }
            catch (e) {
              console.log(e);
              this.$showToast('上传失败')
            }
            try {
              // 生成唯一文件名
              console.log('上传图片key', key, token);
              let observable = qiniu.upload(this.fileArr[i], 'problem/' + key, token);
              observable.subscribeAction({
                next() {
                },
                error(err) {
                  reject(err);
                },
                complete(res) {
                  console.log('图片上传结果-->', res.key);
                  resolve(res.key);
                }
              });
            }
            catch (err) {
              console.log(err);
              reject();
            }
          });
          arr.push(promise);
        }
        return arr;
      },
      async submit() {
        this.$reportLog('card_problem_submit', 'btn', '提交');
        let promblemChoose = this.problem[this.problemItem.choose] || {};
        let postData = this.postData;
        postData.problemId = promblemChoose.id || 0;
        postData.problemType = promblemChoose.problemType || this.problem[0].problemType;
        if (!postData.problemId && !postData.content) {
          return this.$showToast({ text: '请描述绑卡失败原因' });
        }
        // this.postData.userId = this.user.userId;
        console.log(this.postData);
        // this.$showLoader({ text: '正在上传' });
        // try {
        //   if (this.fileArr.length > 0) {
        //     await this.upLoadImg();
        //     if (this.postData.imageList.length === 0) {
        //       this.$hideLoader();
        //       this.$showToast({ text: '上传图片失败' });
        //       return;
        //     }
        //   }
        // }
        // catch (e) {
        //   console.log(e);
        //   this.$hideLoader();
        //   this.$showToast({ text: '上传图片失败' });
        //   return;
        // }
        try {
          let res = await webapi.problem.submitProblem(this.postData);
          if (res.statusCode === 200) {
            this.$hideLoader();
            this.$router.replace('/successInfo/report/bindcard')
          }
          else {
            this.$hideLoader();
            this.$showToast({ text: res.message });
          }
        }
        catch (e) {
          console.log(e);
          this.$hideLoader();
          this.$showToast({ text: '提交失败' });
        }
      },
      inputReport() {
        this.$reportLog('card_problem_input', 'btn', '其他原因');
      },
      mobileReport() {
        this.$reportLog('card_problem_mobile', 'btn', '修改手机');
      }
    },
    computed: {
      ...mapState({
        user: (state) => state.userState.user || {}
      }),
      ...mapGetters(['common/common'])
    },
    watch: {
        'postData.content': function(newvalue, value) {
            if(newvalue && newvalue.length >= 100) {
                this.postData.content = newvalue.substr(0, 99);
            }
            return newvalue;
        },
    }
  };

</script>
